"use client";

import { ChevronLeft } from "lucide-react";
import Link from "next/link";
import type { ReactNode } from "react";

import { schoolDetailsNavTestIds } from "@/lib/data-test-ids/schools.data-test-ids";
import routes from "@/lib/routes";

export default function SchoolPageBackLink(): ReactNode {
  const jobSearchUrl = routes.getJobSearchOrigin();

  return (
    <nav className="mb-4" aria-label="Breadcrumb">
      <Link
        href={jobSearchUrl}
        className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors group"
        data-testid={schoolDetailsNavTestIds.BACK_TO_SEARCH_BUTTON}
      >
        <ChevronLeft className="h-4 w-4 group-hover:-translate-x-0.5 transition-transform" />
        <span className="font-medium">Back to Job Search</span>
      </Link>
    </nav>
  );
}
